import { render } from "./accordion.vue?vue&type=template&id=05e68602"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"

import "./accordion.vue?vue&type=style&index=0&id=05e68602&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__